import * as momentRoutines from '../momentRoutines';
import * as paths from '../../../Providers/paths';
import * as rootSelectors from '../../../selectors/root';
import { call, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { extractFileTypeFromBase64 } from '../../../helpers/fileTypeRegex';
import { rsf } from '../../../globals/firebase';
import {deleteFileFromStorageSaga, sendStringSaga} from '../../../sagas/filesSaga';
import moment from 'moment';

function* toggleCommentBlock(action) {
    const { id, isBlockedByAdmin } = action.payload;
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const activeMoment = yield select(rootSelectors.selectActiveMomentId);
    yield fork(
        rsf.database.patch,
        paths.moduleData(activeEvent, 'feed', 'Moments', 'comments', activeMoment, id),
        {
            isBlockedByAdmin,
        },
        {
            successActionCreator: momentRoutines.toggleCommentBlockOnMoment.success,
            failureActionCreator: momentRoutines.toggleCommentBlockOnMoment.failure,
        },
    );
}

function* removeMoment(action) {
    const { id, removedByAdmin } = action.payload;
    let status = removedByAdmin === true ? true : false;
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(
        rsf.database.patch,
        paths.moduleData(activeEvent, 'feed', 'Moments', 'posts', id),
        {
            removedByAdmin: status,
        },
        {
            successActionCreator: momentRoutines.removeMoment.success,
            failureActionCreator: momentRoutines.removeMoment.failure,
        },
    );
}

function* createMoment(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const alertUser = yield select(rootSelectors.selectAlertUser);

    const { imageURL, text } = action.payload;
    const moment_id = yield call(rsf.database.create, paths.moduleData(activeEvent, 'feed', 'Moments', 'posts'), {
        contentType: 'imageURL',
    });

    const fileType = extractFileTypeFromBase64(imageURL);
    const filePath = paths.storage_moments(activeEvent, moment_id) + `content.${fileType}`;

    const downloadablePath = yield call(sendStringSaga, { filePath, imageURL });

    let alertUserMoment = {
        authorId: 'AlertUser',
        authorName: alertUser.name || 'AlertUser',
        description: text,
        contentType: 'imageURL',
        content: downloadablePath,
        timestamp: parseFloat(moment().format('X')),
    };
    yield fork(
        rsf.database.patch,
        paths.moduleData(activeEvent, 'feed', 'Moments', 'posts', moment_id),
        alertUserMoment,
        {
            successActionCreator: momentRoutines.createMoment.success,
            failureActionCreator: momentRoutines.createMoment.failure,
        },
    );
}

function* updateMoment(action) {
    const { imageURL, text, id } = action.payload;

    const activeEvent = yield select(rootSelectors.selectActiveEventId);

    //Get current moment
    const moments = yield select(rootSelectors.selectMomentsPosts)
    const currentMoment = moments[action.payload.id]
    const currentImageUrl = currentMoment.content;

    let alertUserMoment = {
        description: text,
        modified:parseFloat(moment().format('X')),
    };
    // If image in payload is different, let's upload new one
    if(action.payload.imageURL !== currentMoment.content){
        //Remove current moment photo
        yield call(
            deleteFileFromStorageSaga,
            currentImageUrl,
            paths.storage_moments(activeEvent, id),
        );
        //Upload new photo to storage
        const fileType = extractFileTypeFromBase64(imageURL);
        const filePath = paths.storage_moments(activeEvent, id) + `content.${fileType}`;
        const downloadablePath = yield call(sendStringSaga, { filePath, imageURL });
        //Update outgoing payload to include new image path
        alertUserMoment['content'] = downloadablePath;
    }


    yield fork(
        rsf.database.patch,
        paths.moduleData(activeEvent, 'feed', 'Moments', 'posts', id),
        alertUserMoment,
        {
            successActionCreator: momentRoutines.createMoment.success,
            failureActionCreator: momentRoutines.createMoment.failure,
        },
    );
}

function* addComment(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const activeMoment = yield select(rootSelectors.selectActiveMomentId);
    const alertUser = yield select(rootSelectors.selectAlertUser);

    let comment = {
        senderId: 'AlertUser',
        senderName: alertUser.name || 'AlertUser',
        text: action.payload,
        timestamp: moment().format('X'),
    };

    yield fork(
        rsf.database.create,
        paths.moduleData(activeEvent, 'feed', 'Moments', 'comments', activeMoment),
        comment,
        {
            successActionCreator: momentRoutines.addComment.success,
            failureActionCreator: momentRoutines.addComment.failure,
        },
    );
}

function* syncMomentsSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleData(activeEvent, 'feed', 'Moments'), {
        successActionCreator: momentRoutines.syncMoments.success,
        failureActionCreator: momentRoutines.syncMoments.failure,
    });
}

export function* resetMomentsSync() {
    yield put(momentRoutines.stopSyncingMoments.trigger());
    yield put(momentRoutines.syncMoments());
}

export default function* rootSaga() {
    yield takeEvery(momentRoutines.removeMoment.TRIGGER, removeMoment);
    yield takeEvery(momentRoutines.toggleCommentBlockOnMoment.TRIGGER, toggleCommentBlock);
    yield takeEvery(momentRoutines.addComment.TRIGGER, addComment);
    yield takeEvery(momentRoutines.createMoment.TRIGGER, createMoment);
    yield takeEvery(momentRoutines.updateMoment.TRIGGER, updateMoment);

    while (yield take(momentRoutines.syncMoments.TRIGGER)) {
        const bgMomentsSync = yield fork(syncMomentsSaga);
        yield take(momentRoutines.stopSyncingMoments.TRIGGER);
        yield cancel(bgMomentsSync);
    }
}
